import { useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { VALIDATION_REGEXP } from '@r1-frontend/ui-react/components/input/input';
import Select, { IOption } from '@r1-frontend/ui-react/components/select/select';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { FullWidthListContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import {
    fillEmail,
    selectEmail,
} from '~/src/features/payments-abn/store/actionCreators';
import { confirmedEmails } from '~/src/features/payments-abn/store/selectors/emails';
import { TState } from '~/src/store';

import * as ST from './styled';

/**
 * Форма для ввода email
 */
export const EmailInput = ({ ...rest }): JSX.Element => {
    const dispatch = useDispatch();

    const { paymentData, emails } = useSelector((state: TState) => ({
        paymentData: state.payment.paymentData,
        emails: confirmedEmails(state),
    }), shallowEqual);

    const { email } = paymentData;

    const [bufferEmail, setBufferEmail] = useState('');
    const [isEmailValid, setIsEmailValid] = useState(true);

    const onChangeEmailHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setBufferEmail(event.target.value);
    };

    const onBlurEmailHandler = (event: React.FocusEvent<HTMLInputElement>) => {
        if (VALIDATION_REGEXP.email.test(event.target.value) || event.target.value === '') {
            setIsEmailValid(true);
            dispatch(fillEmail(event.target.value));
        } else {
            setIsEmailValid(false);
        }
    };

    return (
        <FullWidthListContainer $size={4} $direction='column' {...rest}>
            <Paragraph4 $smaller={true} $color={COLORS.TextSecondary}>Email для отправки чека</Paragraph4>
            {typeof email === 'string'
                ? <ST.InputEmail
                    inputType={'email'}
                    value={bufferEmail}
                    onChange={onChangeEmailHandler}
                    onBlur={onBlurEmailHandler}
                    isNotValid={!isEmailValid}
                    errorMessage={'Email некорректный.'}
                />
                : <Select
                    value={email}
                    options={emails}
                    onChange={(option: IOption<string>) => dispatch(selectEmail(option))}
                />
            }
        </FullWidthListContainer>
    );
};
